import { useState, useEffect } from "react";
import API from "../services/api";
import Swal from "sweetalert2";
import Sidebar from "./Sidebar";
import "../styles/stock.css";
import { useNavigate } from "react-router-dom";

export default function StockManagement() {
  const [stocks, setStocks] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const API_BASE = "/stock";

  // new code for search filter and pagination start

  const [searchType, setSearchType] = useState("product");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 30;

  // new code for search filter and pagination end

  const navigate = useNavigate();

  const loadVehicles = async () => {
    const res = await API.get("/stats/vehicles");

    // unique brands
    const uniqueBrands = [...new Set(res.data.map(v => v.brand))];
    setBrands(uniqueBrands);

    setModels(res.data);
  };


  // 1. Fetch Stocks
  const fetchStocks = async () => {
    try {
      const res = await API.get(API_BASE);
      setStocks(res.data);
    } catch (err) {
      Swal.fire("Session Expired", "Please login again", "warning");
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
  };

  useEffect(() => { fetchStocks(); loadVehicles(); }, []);

  // 2. Add Logic (Direct Form)

  const handleAdd = async () => {
    let selectedBrand = "";

    const { value: form } = await Swal.fire({
      title: "Add New Product",
      showCancelButton: true,
      cancelButtonText: "Cancel",
      background: "#0f172a",
      color: "#fff",

      html: `
      <div style="display:grid; grid-template-columns: 1fr 1fr; gap:8px; margin-bottom:10px;">
        <select id="brand" class="swal2-select">
          <option value="">Brand</option>
          ${brands.map(b => `<option value="${b}">${b}</option>`).join("")}
        </select>

        <select id="model" class="swal2-select">
          <option value="">Model</option>
        </select>
      </div>

      <input id="n" class="swal2-input" placeholder="Part Name">
      <input id="p" type="number" class="swal2-input" placeholder="Price">
      <input id="q" type="number" class="swal2-input" placeholder="Quantity">
      <input id="u" type="text" class="swal2-input" placeholder="Unit (kg, feet || null)">
      <input id="d" type="number" class="swal2-input" placeholder="Desk (optional)">
    `,

      didOpen: () => {
        const brandSelect = document.getElementById("brand");
        const modelSelect = document.getElementById("model");

        brandSelect.addEventListener("change", () => {
          selectedBrand = brandSelect.value;

          const relatedModels = models
            .filter(v => v.brand === selectedBrand)
            .map(v => v.model);

          modelSelect.innerHTML =
            `<option value="">Model</option>` +
            [...new Set(relatedModels)]
              .map(m => `<option value="${m}">${m}</option>`)
              .join("");
        });
      },

      preConfirm: () => {
        const brandVal = document.getElementById("brand").value;
        const modelVal = document.getElementById("model").value;


        return {
          name: document.getElementById("n").value,
          price: document.getElementById("p").value,
          quantity: document.getElementById("q").value,
          desk: document.getElementById("d").value || 0,
          unit: document.getElementById("u").value || "N/A",

          // 👇 MAIN FIX
          brand: brandVal ? brandVal : null,
          model: modelVal ? modelVal : null,
        };
      }
    });

    if (!form) return;

    // ✅ Only required fields check
    if (!form.name || !form.price || !form.quantity) {
      Swal.fire("Error", "Name, price and quantity required", "warning");
      return;
    }

    try {
      await API.post(`${API_BASE}/add`, form);
      fetchStocks();
      Swal.fire("Success", "Product Added", "success");
    } catch {
      Swal.fire("Error", "Failed to add product", "error");
    }
  };


  // 3. Update Logic (Direct Form)


  const handleUpdate = async (item) => {
    const { value: form } = await Swal.fire({
      title: "Update Stock",
      background: "#0f172a",
      color: "#fff",
      showCancelButton: true,

      html: `
            <div >
            <select id="ub" class="swal2-select">
                <option value="" disabled selected>Select Brand</option>
                ${brands
          .map(
            (b) =>
              `<option value="${b}" ${b === item.brand ? "selected" : ""
              }>${b}</option>`
          )
          .join("")}
            </select>

            <select id="um" class="swal2-select">
                <option value="" disabled selected>Select Model</option>
                ${item.model
          ? `<option value="${item.model}" selected>${item.model}</option>`
          : ""
        }
            </select>
            </div>

            <input id="un" class="swal2-input" placeholder="Part Name" value="${item.name || ""}">
            <input id="up" type="number" class="swal2-input" placeholder="Price" value="${item.price || ""}">
            <input id="uq" type="number" class="swal2-input" placeholder="Quantity" value="${item.quantity || ""}">
            <input id="uu" type="text" class="swal2-input" placeholder="Unit" value="${item.unit || ""}">
            <input id="ud" type="number" class="swal2-input" placeholder="Desk (optional)" value="${item.desk || ""}">
        `,

      didOpen: () => {
        const brandSelect = document.getElementById("ub");
        const modelSelect = document.getElementById("um");

        brandSelect.addEventListener("change", () => {
          const selectedBrand = brandSelect.value;

          const relatedModels = models
            .filter((v) => v.brand === selectedBrand)
            .map((v) => v.model);

          modelSelect.innerHTML =
            `<option value="">Select Model</option>` +
            [...new Set(relatedModels)]
              .map((m) => `<option value="${m}">${m}</option>`)
              .join("");
        });
      },

      preConfirm: () => ({
        name: document.getElementById("un").value,
        brand: document.getElementById("ub").value || null,
        model: document.getElementById("um").value || null,
        price: document.getElementById("up").value,
        quantity: document.getElementById("uq").value,
        unit: document.getElementById("uu").value || "N/A",
        desk: document.getElementById("ud").value || "0",
      }),
    });

    if (form) {
      try {
        await API.put(`${API_BASE}/${item._id}`, form);
        fetchStocks();
        Swal.fire("Updated", "Changes saved", "success");
      } catch (err) {
        Swal.fire("Error", "Update failed", "error");
      }
    }
  };


  // 4. Delete Logic (Simple Confirmation)
  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "Product delete ho jayega!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#ef4444',
      background: '#0f172a', color: '#fff'
    });

    if (result.isConfirmed) {
      try {
        await API.delete(`${API_BASE}/${id}`);
        fetchStocks();
        // Swal.fire('Deleted!', 'Product removed.', 'success',1500);
        Swal.fire({
          title: 'Deleted!',
          text: 'Product removed successfully..',
          icon: 'success',
          timer: 1500,
          showConfirmButton: true
        });
      } catch (err) {
        // Swal.fire("Error", "Deletion failed", "error"); 
        Swal.fire({
          title: 'Error!',
          text: 'Deletion failed',
          icon: 'error',
          timer: 1500,
          showConfirmButton: true
        });
      }
    }
  };

  // const filtered = stocks.filter(s => s.name.toLowerCase().includes(searchTerm.toLowerCase()));

  const filtered = stocks.filter((item) => {
    const value = searchTerm.trim().toLowerCase();

    // Agar sirf space ya empty hai to sab show karo
    if (!value) return true;

    if (searchType === "product") {
      return item.name?.toLowerCase().includes(value);
    }

    if (searchType === "brand") {
      return item.brand?.toLowerCase().includes(value);
    }

    if (searchType === "model") {
      return item.model?.toLowerCase().includes(value);
    }

    return true;
  });

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, searchType]);

  // Total pages
  const totalPages = Math.ceil(filtered.length / itemsPerPage);

  // Index calculate karo
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  // Current page ka data
  const currentData = filtered.slice(startIndex, endIndex);





  return (
    <div className="dashboard-layout">
      <Sidebar />
      <div className="main-content">
        <header className="stock-header">
          <div className="header-left">
            <h1>Inventory & Stock</h1>
            <p>Manage your vehicle parts and supplies</p>
          </div>

          <button className="btn-primary" onClick={handleAdd}>
            <i className="fas fa-plus"></i> Add New Stock
          </button>
        </header>

        <div className="stock-tools">
          <div className="search-bar">
            <i className="fas fa-search"></i>

            {/* NEW DROPDOWN */}
            <select
              value={searchType}
              onChange={(e) => setSearchType(e.target.value)}
              className="search-filter"
            >
              <option value="product">Product</option>
              <option value="brand">Car Brand</option>
              <option value="model">Car Model</option>
            </select>

            <input
              type="text"
              placeholder="Search parts (e.g. Leather Cover)..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        <div className="table-container">
          <table className="stock-table">
            <thead>
              <tr>
                <th>No.</th>
                <th>Part Name</th>
                <th>Brand / Model</th>
                <th>Price</th>
                <th>Stock Qty</th>
                <th>Unit</th>
                <th>Desk</th>
                <th>Status</th>
                <th>Actions</th>
                <th>Create-Date</th>
              </tr>
            </thead>
            <tbody>
              {filtered.length > 0 ? (
                currentData.map((item, index) => (
                  <tr key={item._id}>
                    <td className="part-name">
                      {startIndex + index + 1}
                    </td>

                    <td
                      className="part-name clickable"
                      onClick={() => navigate(`/product/${item._id}`)}
                    >
                      {item.name}
                    </td>

                    <td>
                      {item.brand && item.model
                        ? `${item.brand} / ${item.model}`
                        : "No Selected"}
                    </td>
                    <td className="part-price">₹{item.price}</td>
                    <td className="part-qty">{item.quantity}</td>
                    <td>{item.unit}</td>
                    <td className="part-desk">
                      {item.desk || 0}
                    </td>
                    <td>
                      <span
                        className={
                          parseFloat(item.quantity) > 5
                            ? "status-tag instock"
                            : "status-tag lowstock"
                        }
                      >
                        {parseFloat(item.quantity) > 5 ? "In Stock" : "Low Stock"}
                      </span>
                    </td>

                    <td className="action-btns">
                      <button title="Edit" className="btn-edit" onClick={() => handleUpdate(item)}>
                        <i className="fas fa-pen-to-square"></i>
                      </button>
                      <button title="Delete" className="btn-delete" onClick={() => handleDelete(item._id)}>
                        <i className="fas fa-trash-can"></i>
                      </button>
                    </td>
                    <td>{new Date(item.updatedAt).toLocaleString()}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="no-data-msg">
                    <div className="empty-state">
                      <i className="fas fa-box-open"></i>
                      <p>No products found in your inventory.</p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          <div className="pagination">
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(currentPage - 1)}
            >
              Previous
            </button>

            <span>
              Page {currentPage} of {totalPages || 1}
            </span>

            <button
              disabled={currentPage === totalPages || totalPages === 0}
              onClick={() => setCurrentPage(currentPage + 1)}
            >
              Next
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}
